import { GeneralPropsType } from "@/common/types";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import { useGlobalData } from "@/contexts/GlobalData";
import { ReactNode } from "react";
import FormatterNumber from "../FormatterNumber";
export interface Token {
  name?: ReactNode;
  icon?: string;
  des?: string;
  active?: boolean;
  balance?: number | string;
  balanceCurrency?: number | string;
  networks?: any[];
}
interface TokenWithdrawOptionPropsType extends GeneralPropsType {
  token?: Token;
  onClick?: (data?: any) => any;
}
function TokenWithdrawOption({
  token,
  onClick
}: TokenWithdrawOptionPropsType) {
  const prefix = "token_w_";
  const {
    translate
  } = useGlobalData();
  return <div onClick={onClick} className={clsx("flex items-center gap-1.5 p-3 rounded-2xl cursor-pointer", {
    "bg-secondary/[0.16] border border-secondary": token?.active,
    "bg-white/[0.16]": !token?.active
  })} data-sentry-component="TokenWithdrawOption" data-sentry-source-file="index.tsx">
            <DynamicSizeIcon width={16} icon={token?.icon} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
            <div className="flex flex-col gap-0.5">
                <DynamicFontSize fontSize={14} className="text-white leading-[140%] font-medium not_apply_adjust_color_tbk" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {token?.name}
                </DynamicFontSize>
                <DynamicFontSize fontSize={11} className="text-description leading-[140%] font-medium" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {token?.des}
                </DynamicFontSize>
            </div>

            <div className="flex flex-col items-end gap-0.5 ml-auto">
                <DynamicFontSize fontSize={14} className="text-white leading-[140%] font-medium" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    <FormatterNumber value={token?.balance} lengthValueAllowed={8} data-sentry-element="FormatterNumber" data-sentry-source-file="index.tsx" />
                </DynamicFontSize>
                <DynamicFontSize fontSize={11} className="text-description leading-[140%]" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    <FormatterNumber value={token?.balanceCurrency} start="$" isLessThan data-sentry-element="FormatterNumber" data-sentry-source-file="index.tsx" />
                </DynamicFontSize>
            </div>
        </div>;
}
export default TokenWithdrawOption;